import { ApiCallOptions, Dict, SfFormData } from "@/types/generalTypes";
import apiCall from "../net/apiCall";
import getFormData from "./getFormData";
import { validateForm } from "./validation";
import { clearApiErrors } from "@/state/appState";

interface SubmitFormOptions {
  extraFields?: Dict<any> | null;
  params?: Dict<any> | null;
  idField?: string;
  apiOptions?: ApiCallOptions;
}

const defaultOptions = {
  extraFields: null,
  params: null,
  idField: "id",
};

async function submitForm(
  url: string,
  formData: SfFormData,
  targetItem: Dict<any> | null = null,
  submitOptions?: SubmitFormOptions,
  clearErrors = true,
) {
  const validatedData = validateForm(formData);
  if (!validatedData.isValid) {
    return {
      formData: validatedData,
      response: { success: false, data: null, errorDetails: null },
    };
  }
  const options = { ...defaultOptions, ...submitOptions };
  const sendData = { ...getFormData(formData), ...options.extraFields };
  let method = "POST";
  if (targetItem) {
    url += "/" + targetItem[options.idField];
    method = "PATCH";
  }
  if(clearErrors) {
    clearApiErrors();
  }
  const response = await apiCall(
    url,
    options.params,
    { method },
    sendData,
    options?.apiOptions
  );
  validatedData.isValid =
    response.success &&
    (response.data.success === undefined || response.data.success);
  if(!validatedData.isValid) {
    const errors = getErrors(response);
    for (const i in errors) {
      validatedData.fields[i].errors = errors[i];
    }
  }
  return {
    formData: validatedData,
    response,
  };
}

function getErrors(data: any) {
  if(data.data?.errors) {
    return data.data.errors;
  }
  const res: Dict<any> = {};
  if(data.errorDetails) {
    if(Array.isArray(data.errorDetails)) {
      for(const err of data.errorDetails) {
        if(!res[err.field]) {
          res[err.field] = [];
        }
        res[err.field].push(err.message);
      }
    }
  }
  return res;
}

export default submitForm;
